import { render, staticRenderFns } from "./horse-slider.vue?vue&type=template&id=07de957f&"
import script from "./horse-slider.vue?vue&type=script&lang=js&"
export * from "./horse-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports